let breakpoints = {
  xs: 575,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
};

export default {
  namespaced: true,
  state: {
    breakpoints: breakpoints,
    currentBreakPoint: "sm",
  },
  mutations: {
    UPDATE_BREAK_POINT(state, value) {
      state.currentBreakPoint = value;
    },
    SET_BREAK_POINTS(state, value) {
      state.breakpoints = value;
    },
  },
};
